import React from "react";
import AdminHome from "./Home";
export default AdminHome;
